import type { IAttentionStatusApi } from '../api/types'

/** Read the shared `AttentionDict`, keeping one definition per bit. */
export const getAttentionStatusCatalog = (rows: IAttentionStatusApi[]): IAttentionStatusApi[] => {
  const byBitValue = new Map<number, IAttentionStatusApi>()

  rows.forEach((row) => {
    if (!byBitValue.has(row.BitValue)) {
      byBitValue.set(row.BitValue, row)
    }
  })

  return [...byBitValue.values()]
}
